import { useState, useCallback } from 'react';

export interface SelectedProcess {
  groupName: string;
  itemLabel: string;
  price: number;
}

export interface EstimateSnapshot {
  pyeong: number;
  selectedItems: SelectedProcess[];
  totalMin: number;
  totalMax: number;
}

// Module-level singleton state (shared across components without context)
let _snapshot: EstimateSnapshot | null = null;
const _listeners: Set<() => void> = new Set();

function notify() {
  _listeners.forEach((fn) => fn());
}

export function saveEstimateSnapshot(snapshot: EstimateSnapshot) {
  _snapshot = snapshot;
  notify();
}

export function getEstimateSnapshot(): EstimateSnapshot | null {
  return _snapshot;
}

export function clearEstimateSnapshot() {
  _snapshot = null;
  notify();
}

export function useEstimateSnapshot() {
  const [, forceUpdate] = useState(0);

  const subscribe = useCallback(() => {
    const handler = () => forceUpdate((n) => n + 1);
    _listeners.add(handler);
    return () => _listeners.delete(handler);
  }, []);

  // Subscribe on mount
  useState(() => {
    const handler = () => forceUpdate((n) => n + 1);
    _listeners.add(handler);
    return () => _listeners.delete(handler);
  });

  return {
    snapshot: _snapshot,
    clear: clearEstimateSnapshot,
  };
}
